export const isTokenExpired = (token: string) =>
    Date.now() >= JSON.parse(window.atob(token.split('.')[1])).exp * 1000;
